<div [ngClass]="wrapperClass" [ngStyle]="wrapperStyle" aria-live="assertive" aria-atomic="true">
  <p>
    @if (this.showConfirmation) {
      <ng-content></ng-content>
    }
  </p>
</div>
